import React, { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import './ConclusionInput.scss';
import showdown from 'showdown';
import sanitizeHtml from 'sanitize-html';
import formatWrongMarkdownURL from '../../helpers/formatWrongMarkdownURL';

const converter = new showdown.Converter();
const sanitizeConf = {
    allowedTags: [
        'b',
        'i',
        'a',
        'p',
        'br',
        'ul',
        'li',
        'ol',
        'h1',
        'h2',
        'h3',
        'span',
    ],
    allowedAttributes: { a: ['href'] },
};

const ConclusionInput = ({ value, placeholder, onSave, disabled }) => {
    const [editorHtml, setEditorHtml] = useState(value);
    const [focused, setFocused] = useState(false);
    const [timer, setTimer] = useState(null);

    const handleEditorChange = (html) => {
        if (disabled) return;
        const sanitizedHtml = sanitizeHtml(html, sanitizeConf); // avoid xss attack

        if (sanitizedHtml === value) return; // avoid unnecessary PUT request

        let markdownValue = converter.makeMarkdown(sanitizedHtml);

        // sometimes the markdown add two extra lines at the end --> /n/n, remove if exist
        if (markdownValue.endsWith('\n\n'))
            markdownValue = markdownValue.slice(0, -2);

        // the converter library has a little bug that adds "<" and ">" symbols at the end and at the beginning of the markdown URL
        // https://github.com/showdownjs/showdown/issues/809
        // remove them
        const cleanedMarkdown = formatWrongMarkdownURL(markdownValue);

        // Clear the existing timer
        if (timer) {
            clearTimeout(timer);
        }

        // Set a new timer to make the PUT request after 1000ms (1 second)
        setTimer(
            setTimeout(() => {
                onSave(cleanedMarkdown);
            }, 1500)
        );
        setEditorHtml(html);
    };

    useEffect(() => {
        setEditorHtml(value);
    }, [value]);

    // Clear the timer on component unmount to prevent memory leaks
    useEffect(() => {
        return () => {
            if (timer) {
                clearTimeout(timer);
            }
        };
    }, [timer]);

    return (
        <ReactQuill
            value={editorHtml}
            onChange={handleEditorChange}
            placeholder={placeholder}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
            className={`cg-conclusion-editor ${
                focused ? 'cg-conclusion-editor__focused' : ''
            } ${disabled ? 'cg-conclusion-editor__disabled' : ''}`}
            autoFocus={true}
            readOnly={disabled}
        />
    );
};

export default ConclusionInput;
